import _get from 'lodash/get';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import RestClient from '../RestClient/RestClient';
import { RestConfig, getHostConfig } from '../Common/RestConfig';
import * as OrderApiConstants from './OrderApiConstants';
import { apiHosts } from '../RestClient/FetchHelper.config';
import LocalStorage from '../helpers/LocalStorage';

export const getStoreById = (store) => {
    if (store) {
        if (_get(store, 'storeId').indexOf('"') !== -1) {
            store.storeId = store.storeId.replace(/"/g, '');
            const _userStore = LocalStorage.getData('userStore', true);
            if (_userStore && _userStore.indexOf('"') !== -1) {
                LocalStorage.setData('userStore', _userStore.replace(/"/g, ''), true);
            }
        }

        const config = {
            url: `${OrderApiConstants.STORES_URL}/${store.storeId}`,
            version: '/v1',
            credentials: 'include',
            apiHost: apiHosts.browse,
        };

        return RestClient.get(config).catch(
            /* istanbul ignore next */
            // Ignoring this part in coverage as error can not be simulated
            (error) => {
                console.log(`request failed ${error}`);
            }
        );
    }
    return null;
};

export const getStoresWithBopisAvailability = (params) => {
    let itemCount = Cookies.load('ItemCount');
    itemCount = itemCount && Number(itemCount);
    let url = '';
    let config = RestConfig.v1DraftConfig();
    config = getHostConfig(config);
    if (params && params.payload && params.payload.skus && params.payload.skus.length > 0) {
        url = `${OrderApiConstants.BASE_URL}/${params.accountId}/${OrderApiConstants.CHECK_STORES_URL_V2}`;
        config.url = url;
    } else if (itemCount || (params && params.payload && params.payload.showCartItemAvailability)) {
        url = `${OrderApiConstants.BASE_URL}/${params.accountId}/${OrderApiConstants.CHECK_STORES_URL}`;
        config.url = url;
    } else {
        config = {};
        config.url = `/${OrderApiConstants.STORES_URL}`;
        config.version = '/v1';
        config.credentials = 'include';
        config.apiHost = apiHosts.browse;
    }
    config.accessToken = params.accessToken;
    config.xClientSource = params.payload.xClientSource;
    config.params = params.payload;
    config.encode = false;
    return RestClient.get(config)
        .then(
            /* istanbul ignore next */
            (res) => res
        )
        .catch(
            /* istanbul ignore next */
            // Ignoring this part in coverage as error can not be simulated
            (error) => {
                console.log('StoresApi: Store with availability request failed: ', error);
            }
        );
};

export const getStoresWithAvailability = (params) => {
    let checkStoresURL = OrderApiConstants.CHECK_STORES_URL;

    if (params.featureFlags && params.featureFlags.v2StoreAPI) {
        checkStoresURL = OrderApiConstants.CHECK_STORES_URL_V2;
    }

    const url = `${OrderApiConstants.BASE_URL}/${params.accountId}/${checkStoresURL}`;

    let config = RestConfig.v1DraftConfig();

    config = getHostConfig(config);
    config.url = url;
    config.accessToken = params.accessToken;
    config.params = params.payload;

    return RestClient.get(config)
        .then(
            /* istanbul ignore next */
            (res) => res
        )
        .catch(
            /* istanbul ignore next */
            // Ignoring this part in coverage as error can not be simulated
            (error) => {
                console.log('StoresApi: Store with availability request failed: ', error);
            }
        );
};

export const getStoresByPageLink = (params) => {
    const config = RestConfig.pageLinkConfig();
    let url = params.payload.pageLink;
    if (url.indexOf('v2.1') !== -1) {
        url = url.replace('v2.1', 'v2');
    } else if (url.indexOf('v5') !== -1 && url.indexOf('account-api') !== -1) {
        url = url.replace('v5', 'v1');
    }
    config.url = url;
    config.accessToken = params.accessToken;

    return RestClient.get(config)
        .then((res) => res)
        .catch(
            /* istanbul ignore next */
            // Ignoring this part in coverage as error can not be simulated
            (error) => {
                console.log('StoresApi: Store with page link request failed: ', error);
            }
        );
};

export const getMoreStoresByLink = (params) => {
    let config = {
        url: params.payload.pageLink,
        external: true,
        apiHost: apiHosts.browse,
        credentials: 'include',
        acceptVersion: '1',
        version: '/v1',
        XForwardedChannelHeaderHost: true,
    };
    config = getHostConfig(config);
    return RestClient.get(config)
        .then((res) => res)
        .catch(
            /* istanbul ignore next */
            // Ignoring this part in coverage as error can not be simulated
            (error) => {
                console.log('StoresApi: Store with page link request failed: ', error);
            }
        );
};
